/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { hierarchiesControllerGetAncestors } from "./hierarchiesControllerGetAncestors";
import { hierarchiesControllerGetChildren } from "./hierarchiesControllerGetChildren";
import { hierarchiesControllerGetDescendants } from "./hierarchiesControllerGetDescendants";
import { hierarchiesControllerGetHierarchy } from "./hierarchiesControllerGetHierarchy";
import { hierarchiesControllerGetMembers } from "./hierarchiesControllerGetMembers";
import { hierarchiesControllerGetMemberSuggestions } from "./hierarchiesControllerGetMemberSuggestions";
import { hierarchiesControllerGetPermissions } from "./hierarchiesControllerGetPermissions";
import { hierarchiesControllerGetStatistics } from "./hierarchiesControllerGetStatistics";

export function hierarchiesService() {
  return { hierarchiesControllerGetHierarchy, hierarchiesControllerGetChildren, hierarchiesControllerGetAncestors, hierarchiesControllerGetDescendants, hierarchiesControllerGetMembers, hierarchiesControllerGetMemberSuggestions, hierarchiesControllerGetPermissions, hierarchiesControllerGetStatistics }
}